import React, { useState } from "react";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import css from "./InsightFilterModal.module.css";
import { MobileFilter } from "../../../../../stories/MobileFilter/MobileFilter";
import { Button } from "../../../../../stories/Button/Button";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import {
  CancelIconBlack,
  BookmarkIconBlack,
} from "../../../../../constant/imagePath";
import Colors from "../../../../../stories/assets/Colors";
import { ReactSVG } from "react-svg";
import ModalSkeletonCssClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import MonthSmallCalander from "../../../../../components/MonthSmallCalander";
const InsightFilterModal = ({ show, setShow, location, setLocation }) => {
  const [filtervalue, setFiltervalue] = useState("This Week");
  const mobileFilters = [
    "This Week",
    "This Month",
    "This Quarter",
    "This Year",
    "All Time",
  ];
  return (
    <>
      <style jsx>{`
        .${ModalSkeletonCssClasses.body} {
          padding: 0px;
        }
        .modal .modal-dialog {
          width: 100% !important;
          margin: 0px !important;
        }
        .modal .modal-dialog {
          max-width: 100% !important;
          height: 100%;
        }
        .modal-content {
          min-height: 100%;
        }
        .modal {
          border-radius: 0px !important;
          background: white;
        }
      `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        width={"100%"}
      >
        <Row className="g-0">
          <Col sm={12} md={12}>
            <div
              style={{
                borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
              className={[css.FilterHeader].join(" ")}
            >
              <ReactSVG src={CancelIconBlack} onClick={() => setShow(false)} />

              <h6
                style={{
                  ...Fonts.b3,
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Filters
              </h6>
              <ReactSVG
                src={BookmarkIconBlack}
              // onClick={() => setIsSavedFilter(true)}
              />
            </div>
          </Col>
          <Col sm={12} md={12}>
            <div
              className={[css.pb16].join(" ")}
              style={{
                borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
            >
              <div className={[css.DropDownDiv, css.mb32].join(" ")}>
                <DropDown
                  label={"Choose location"}
                  placeholder={"All"}
                  options={[
                    {
                      value: "All Locations",
                      label: "All Locations",
                    },
                    {
                      value: "Royal-Tennis-Court",
                      label: "Royal Tennis Court",
                    },
                    {
                      value: "Green-Tennis-Court",
                      label: "Green Tennis Court",
                    },
                  ]}
                  setter={setLocation}
                  state={location}
                />
              </div>

              <div className={[css.filterDiv].join(" ")}>
                <MobileFilter
                  filters={mobileFilters}
                  state={filtervalue}
                  setter={setFiltervalue}
                />
              </div>
            </div>

            <div className={[css.calenderDiv].join(" ")}>
              {/* Calender will be displayed here */}
              <MonthSmallCalander />
            </div>

            <div
              style={{
                borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
              className={[css.footerBtnsDiv].join(" ")}
            >
              <LinkButtonWithIcon
                text={"Clear All"}
                textColor={Colors.neutralShadesOfNero}
                customStyle={{
                  ...Fonts.b1Mobile,
                }}
              />

              <Button
                label={"Apply"}
                customStyle={{
                  ...Fonts.b1Mobile,
                  padding: "12px 32px",
                  border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  width: "156px",
                }}
                primary={true}
                size="Large"
              />
            </div>
          </Col>
        </Row>
      </ModalSkeleton>
    </>
  );
};
export default InsightFilterModal;
